import { PageHeader, Styles } from '@/components'
import usePageTitle from '@/hooks/usePageTitle'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const reports = [
  {
    path: 'clinical-cares-termal-map',
    icon: 'fa-map',
    label: 'Mapa térmico de atendimentos clínicos',
    description: 'Mostra as áreas com maior frequência de solicitações',
  },
  {
    path: 'clinical-cares-in-map',
    icon: 'fa-map-marker-alt',
    label: 'Atendimentos clínicos no mapa',
    description: 'Mostra os atendimentos no lugar onde foram solicitados',
  },
  {
    path: 'clinical-cares-by-region',
    icon: 'fa-map',
    label: 'Atendimentos clínicos por região',
    description: 'Mostra os atendimentos pelas regiões',
  },
  {
    path: 'clinical-cares-by-clinic',
    icon: 'fa-clinic-medical',
    label: 'Atendimentos clínicos por clínica',
  },
  {
    path: 'clinical-cares-by-month',
    icon: 'fa-calendar',
    label: 'Atendimentos clínicos por mês',
  },
  {
    path: 'clinical-cares-by-year',
    icon: 'fa-hourglass-half',
    label: 'Atendimentos clínicos por ano',
  },
  {
    path: 'clinical-cares-by-breed',
    icon: 'fa-paw',
    label: 'Atendimentos clínicos por raça e espécie',
  },
  {
    path: 'clinical-cares-by-classification',
    icon: 'fa-tags',
    label: 'Atendimentos clínicos por classificação',
  },
  {
    path: 'clinical-cares-by-priority',
    icon: 'fa-exclamation-triangle',
    label: 'Atendimentos clínicos por prioridade',
  },
  {
    path: 'clinical-cares-by-user',
    icon: 'fa-user',
    label: 'Atendimentos clínicos por usuário',
    description: 'Quantidade de atendimentos solicitados por usuário do município',
  },
  {
    path: 'clinical-care-item-clinic-balances',
    icon: 'fa-star-of-life',
    label: 'Estoque de itens clínicos',
    description: 'Consulta do estoque de itens clínicos das clínicas',
  },
]

function ClinicalCaresMenu({ title }) {
  usePageTitle({ title })

  const { pathname } = useLocation()

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Relatórios por atendimento clínico"
        subtitle="Selecione o relatório que deseja visualizar"
        icon="fas fa-clinic-medical"
      />
      <table className="table">
        <thead>
          <tr>
            <th>Relatório</th>
            <th width="1" className="text-right">
              Ações
            </th>
          </tr>
        </thead>
        <tbody>
          {reports.map((report) => (
            <tr key={report.path}>
              <td>
                <i className={`s-rounded p-1 mr-2 fas fa-fw ${report.icon}`} />
                {report.label}
                {Boolean(report.description) && (
                  <small>
                    &nbsp; ({report.description})
                  </small>
                )}
              </td>
              <td className="text-right">
                <Link
                  to={`${pathname}/${report.path}`}
                  className="btn btn-action btn-sm btn-primary"
                >
                  <i className="fas fa-eye" />
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Styles.Container>
  )
}

export default ClinicalCaresMenu
